'use client';

import type { PolicyFaqItem } from './PolicyFaq';
import { PolicyFaq } from './PolicyFaq';

interface PolicySidebarProps {
  items: PolicyFaqItem[];
}

export function PolicySidebar({ items }: PolicySidebarProps) {
  return (
    <div className="flex flex-col gap-20 rounded-large bg-Gray-white py-20">
      <PolicyFaq items={items} />
    </div>
  );
}
